import * as types from './actionTypes';
import { updateTheme as updateThemeInFirestore } from '../databaseRepository/siteManager';
import initialState from '../reducers/initialState';
import { additionalColors, objectDifference } from '../utils/helperFunctions';

export function updateTheme(theme) {
    return (dispatch) => {
        dispatch({ type: types.SITE_CHANGED, payload: { theme } });
    };
}

export function saveTheme() {
    return (dispatch, getState) => {
        const { site, auth } = getState();

        // make sure to only save editable and non-default colors
        const initialTheme = { ...initialState.site.theme, colors: additionalColors(initialState.site.theme.colors) };
        const customTheme = objectDifference(site.theme, initialTheme);

        return updateThemeInFirestore(auth.user.partnerId, customTheme);
    };
}
